import {AxiosError} from 'axios'
import {useEffect, useState} from 'react'
import {listExperimentType} from '../../../modules/auth/core/_requests'
import {useLang} from '../../../../_metronic/i18n/Metronici18n'
import ContentTypePost from '../Posts/ContentTypePost'

function TabContentTableExperimentType({
  searchTerm,
  checkedControl,
  handleChecked,
  id,
  action,
  setEditData,
}: any) {
  const lang = useLang()
  const [contentType, setContentType] = useState([])

  useEffect(() => {
    if (id) {
      getTypeList()
    }
  }, [id])

  useEffect(() => {
    if (action && id) {
      getTypeList()
    }
  }, [action])

  const getTypeList = async () => {
    try {
      const {data} = await listExperimentType(id, 0, '', lang)
      setContentType(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const keys = ['categoryId']

  const typeList = contentType || []

  const search = () => {
    if (searchTerm) {
      return typeList.filter((item: any) =>
        keys.some((key) =>
          String(item[key]).toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())
        )
      )
    } else {
      return typeList
    }
  }

  if (action) {
    return (
      <div className='d-flex flex-column-fluid flex-center'>
        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
      </div>
    )
  }

  return (
    <table className='table table-striped gy-7 gs-7'>
      <thead>
        <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200  '>
          <th className='w-50px'>#</th>
          <th>Type Id</th>
          <th>Type</th>
        </tr>
      </thead>
      <tbody>
        <ContentTypePost
          search={search}
          list={typeList}
          checkedControl={checkedControl}
          handleChecked={handleChecked}
          categorytList={contentType}
          setEditData={setEditData}
        />
      </tbody>
    </table>
  )
}

export default TabContentTableExperimentType
